import thunk from "redux-thunk";
import logger from "redux-logger";
import { combineReducers, createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { LOG_OUT_USER } from './auth/actions';

// Import initial states
import authState from "./auth/initialState";
import placesState from "./places/initialState";
import notificationsState from "./notifications/initialState";
import langState from "./lang/initialState";
import currencyState from "./currency/initialState";

// Import reducers
import authReducer from "./auth/reducer";
import placesReducer from "./places/reducer";
import notificationsReducer from "./notifications/reducer";
import langReducer from "./lang/reducer";
import currencyReducer from "./currency/reducer";

const initialState = {
    auth: authState,
    places: placesState,
    notifications: notificationsState,
    lang: langState,
    currency: currencyState,
};

const appReducer = combineReducers({
    auth: authReducer,
    places: placesReducer,
    notifications: notificationsReducer,
    lang: langReducer,
    currency: currencyReducer,

})

const rootReducer = (state, action) => {
    // Clear all data in redux store to initial.
    if (action.type === LOG_OUT_USER) {
        state = undefined;
    }

    return appReducer(state, action);
};

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'places', 'lang'],
    blacklist: []
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const getMiddleware = () => {
    if (process.env.NODE_ENV === 'development') {
        return [thunk, logger];
    } else {
        return [thunk];
    }
};

const store = createStore(persistedReducer, initialState, applyMiddleware(...getMiddleware()));
const persistor = persistStore(store);

export { store, persistor };
